module.exports = __webpack_public_path__ + "static/media/CMLogo.4a3d7376.png";